import { FamilyBenefit } from '@sales/models/families/family-benefit.model';
import { Family } from '@sales/models/families/family.model';

export class ApiGetFamilyAction {
  static readonly type = '[Family API] Get family';
  constructor(public customerId: string) {}
}

export class ApiGetFamilySuccessAction {
  static readonly type = '[Family API] Get family success';
  constructor(public family: Family) {}
}

export class ApiGetFamilyFailedAction {
  static readonly type = '[Family API] Get family failed';
}

export class ApiGetFamilyBenefitsAction {
  static readonly type = '[Family API] Get family benefits';
  constructor(public familyId: string) {}
}

export class ApiGetFamilyBenefitsSuccessAction {
  static readonly type = '[Family API] Get family benefits success';
  constructor(public benefits: FamilyBenefit[]) {}
}

export class ApiGetFamilyBenefitsFailedAction {
  static readonly type = '[Family API] Get family benefits failed';
}

export class ResetFamilyStateAction {
  static readonly type = '[Family] Reset family state';
}
